module.exports = __webpack_public_path__ + "img/icon-deposit-01.svg";